import cloudStore from "../store/CloudStore";

export const authentications = require("./authentications.json");
export const roles = require("./roles.json");
export const profiles = require("./profiles.json");

export const getProfilesFromMerchant = (merchant) => {
  const profiles = [];

  if (merchant.mynbonnen_merchant) {
    if (merchant.merchantable_type) {
      profiles.push("POS_AND_STANDALONE");
    } else {
      profiles.push("STANDALONE");
      profiles.push("SYNC_ARTICLEGROUPS");
    }
  }
  if (merchant.merchantable_type) {
    profiles.push(merchant.merchantable_type);
    profiles.push("POS");
    if (merchant.merchantable?.sync_articlegroups !== 0) {
      profiles.push("SYNC_ARTICLEGROUPS");
    } else if (merchant.merchantable?.sync_articlegroups === 0) {
      profiles.push("NOT_SYNC_ARTICLEGROUPS");
    }
  }

  if (!merchant.mynbonnen_merchant && !merchant.merchantable_type) {
    profiles.push("STANDALONE");
  }

  if (merchant.paynl_merchants?.length > 0) {
    profiles.push("PAYNL");
  }

  if (merchant.opp_merchant) {
    profiles.push("OPP");
  }

  if (merchant.hubrise_merchant) {
    profiles.push("HUBRISE");
  } else if (cloudStore.userRoles.includes("admin") || cloudStore.userRoles.includes("superadmin")) {
    profiles.push("CREATE_HUBRISE");
  }

  if (merchant.takeaway_merchant) {
    profiles.push("TAKEAWAYCOM");
  }
  return profiles;
};
